import { render, staticRenderFns } from "./resultats.html?vue&type=template&id=48821bb3&scoped=true&external"
import script from "./resultats.js?vue&type=script&lang=js&external"
export * from "./resultats.js?vue&type=script&lang=js&external"
import style0 from "./resultats.scss?vue&type=style&index=0&id=48821bb3&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48821bb3",
  null
  
)

export default component.exports